export function registerPolyfills() {
    console.log('registering polyfills...');

    _Object_assign();
    _function_name();
}

// ==================================================================================================================
// ======= Polyfill - Object.assign =================================================================================
// ======= https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill ==
// ==================================================================================================================

function _Object_assign() {
    if (typeof Object.assign != 'function') {
        (function () {
            Object.assign = function (target: any) {
                'use strict';
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var output = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var source = arguments[index];
                    if (source !== undefined && source !== null) {
                        for (var nextKey in source) {
                            if (source.hasOwnProperty(nextKey)) {
                                output[nextKey] = source[nextKey];
                            }
                        }
                    }
                }
                return output;
            };
        })();
    }
}

// ==================================================================================================================
// ======= Polyfill - Function.prototype.name =======================================================================
// ======= http://matt.scharley.me/2012/03/monkey-patch-name-ie.html ================================================
// ==================================================================================================================
function _function_name() {
    /**
     * Hack in support for Function.name for browsers that don't support it.
     * IE, I'm looking at you.
     **/
    var prot = Function.prototype as any;
    if (prot.name === undefined && Object.defineProperty !== undefined) {
        console.log('Monkey patching function.prototype.name');

        Object.defineProperty(Function.prototype, 'name', {
            get: function () {
                var funcNameRegex = /function\s([^(]{1,})\(/;
                var results = (funcNameRegex).exec((this).toString());
                return (results && results.length > 1) ? results[1].trim() : "";
            },
            set: function (value) {
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/Polyfills.ts
 **/